<div
  [attr.tabindex]="disabled ? null : 0"
  (blur)="onTouched()"
  (keydown)="onKeyDown($event)"
  class="radio-group"
>
  <ng-container *ngFor="let item of items; trackBy: trackByItem">
    <div
      [class.checked]="isChecked(item)"
      (click)="onClick(item)"
      class="radio-container"
      layout-horizontal
      layout-align-items-center
    >
      <ng-template
        [ngTemplateOutlet]="itemTemplate"
        [ngTemplateOutletContext]="{ $implicit: item }"
      >
      </ng-template>
    </div>
  </ng-container>
</div>

<ng-template #optionDefaultTemplate let-item>
  <div class="radio-check">
    <rt-icon [name]="icon" size="small" layout layout-align-items-center layout-justify-center="">
    </rt-icon>
  </div>
  <div class="label">
    {{ item.option }}
  </div>
</ng-template>
